var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerPowerconnectionAutarkic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20.8435V17.8435H7L10.5 12.8435V15.8435H13L9.5 20.8435ZM1 20.8435C0.716667 20.8435 0.479167 20.7477 0.2875 20.556C0.0958333 20.3643 0 20.1268 0 19.8435V3.84351C0 3.56017 0.0958333 3.32267 0.2875 3.13101C0.479167 2.93934 0.716667 2.84351 1 2.84351H3V0.843506H7V2.84351H9C9.28333 2.84351 9.52083 2.93934 9.7125 3.13101C9.90417 3.32267 10 3.56017 10 3.84351V10.8435C9.65 10.8435 9.30833 10.8727 8.975 10.931C8.64167 10.9893 8.31667 11.0768 8 11.1935V4.84351H2V18.8435H4.35C4.48333 19.2268 4.64583 19.5852 4.8375 19.9185C5.02917 20.2518 5.25833 20.5602 5.525 20.8435H1Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerPowerconnectionAutarkic);
export default __webpack_public_path__ + "static/media/tower_powerconnection_autarkic.8230e060a0ecf9ec8896300be8b4efb2.svg";
export { ForwardRef as ReactComponent };